"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _atoms = require("../../../atoms");

var _Pagination = require("./Pagination.style");

var _images = require("../../../assets/images");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const renderPages = (currentIndex, arr) => {
  let length = arr.length;

  if (arr.length >= 8) {
    if (currentIndex <= 4) {
      return [1, 2, 3, 4, '...', arr[length - 1]];
    } else if (currentIndex >= 5 && currentIndex <= arr.length - 4) {
      return [1, '...', currentIndex - 1, currentIndex, currentIndex + 1, '...', arr[length - 1]];
    } else {
      return [1, '...', arr[length - 4], arr[length - 3], arr[length - 2], arr[length - 1]];
    }
  } else {
    return arr;
  }
};

const Pagination = ({
  totalRecords,
  perPage,
  handlePagination,
  setCaption,
  activePageNumber,
  ...props
}) => {
  const [currentIndex, setCurrentIndex] = (0, _react.useState)(activePageNumber);
  (0, _react.useEffect)(() => {
    setCurrentIndex(activePageNumber);
  }, [activePageNumber]);
  const indexArray = (0, _react.useMemo)(() => {
    if (perPage > 0 && totalRecords > 0) {
      const totalPages = Math.ceil(totalRecords / perPage);
      return Array.from({
        length: totalPages
      }).map((v, i) => i + 1);
    } else {
      return [];
    }
  }, [totalRecords, perPage]);
  const [showArray, setShowArray] = (0, _react.useState)([]);

  const handlePageClick = val => {
    setCurrentIndex(val);
    handlePagination(val);
  };

  (0, _react.useEffect)(() => {
    const pages = renderPages(currentIndex, indexArray);
    setShowArray(pages);
    setCaption(`Showing ${perPage * (currentIndex - 1) + 1}-${perPage * currentIndex > totalRecords ? totalRecords : perPage * currentIndex} of ${totalRecords}`);
    return () => {};
  }, [perPage, currentIndex, totalRecords, indexArray, setCaption]);

  const handleNextClick = () => {
    if (currentIndex + 1 <= indexArray[indexArray.length - 1]) {
      setCurrentIndex(i => i + 1);
      handlePagination(currentIndex + 1);
    }
  };

  const handlePreviousClick = () => {
    if (currentIndex - 1 >= indexArray[0]) {
      setCurrentIndex(i => i - 1);
      handlePagination(currentIndex - 1);
    }
  };

  if (indexArray.length === 0) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_Pagination.StyledPagination, props, /*#__PURE__*/_react.default.createElement(_Pagination.StyledPaginationNav, {
    type: "button",
    "data-testid": "previous-nav",
    onClick: handlePreviousClick,
    hide: currentIndex !== indexArray[0]
  }, /*#__PURE__*/_react.default.createElement(_images.LeftArrow, null), /*#__PURE__*/_react.default.createElement(_Pagination.StyledNavText, null, " Previous")), /*#__PURE__*/_react.default.createElement(_Pagination.StyledPages, null, showArray.map((v, i) => {
    return /*#__PURE__*/_react.default.createElement(_Pagination.StyledPageNumber, {
      key: i,
      active: currentIndex === v
    }, typeof v === 'number' ? /*#__PURE__*/_react.default.createElement(_atoms.Link, {
      tabIndex: "0",
      "data-testid": `pageNumber-${v}`,
      type: "tertiary",
      text: v,
      onClick: () => handlePageClick(v)
    }) : v);
  })), /*#__PURE__*/_react.default.createElement(_Pagination.StyledPaginationNav, {
    type: "button",
    "data-testid": "next-nav",
    onClick: handleNextClick,
    hide: currentIndex !== indexArray[indexArray.length - 1]
  }, /*#__PURE__*/_react.default.createElement(_Pagination.StyledNavText, null, "Next"), /*#__PURE__*/_react.default.createElement(_images.RightArrow, null)));
};

exports.Pagination = Pagination;
Pagination.defaultProps = {
  handlePagination: () => {},
  setCaption: () => {},
  activePageNumber: 1
};
Pagination.propTypes = {
  totalRecords: _propTypes.default.number.isRequired,
  perPage: _propTypes.default.number.isRequired,
  handlePagination: _propTypes.default.func.isRequired,
  setCaption: _propTypes.default.func,
  activePageNumber: _propTypes.default.number
};